// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3_BUp","signatureBlock":"Footer_signatureBlock__3TotI","signature":"Footer_signature__3PoMX"};